export default {"src":"/_next/static/media/favicon.cf9c13f8.ico","height":108,"width":108,"blurWidth":0,"blurHeight":0};